/**
 * Represents the type of theme schemes available in the application.
 */ export var PlannerTheme = /*#__PURE__*/ function(PlannerTheme) {
    /** Dark theme */ PlannerTheme["Dark"] = "dark";
    /** Light theme */ PlannerTheme["Light"] = "light";
    /** High Contrast theme */ PlannerTheme["HighContrast"] = "highcontrast";
    return PlannerTheme;
}({});
/**
 * Enumeration of the various themes supported by Teams app
 */ export var TeamsTheme = /*#__PURE__*/ function(TeamsTheme) {
    /** Default theme which is the light theme experience */ TeamsTheme["Default"] = "default";
    /** Dark theme with darker colors and backgrounds */ TeamsTheme["Dark"] = "dark";
    /** High contrast theme with high contrast colors and backgrounds */ TeamsTheme["Contrast"] = "contrast";
    return TeamsTheme;
}({});
/**
 * Evo brand variant colors as derived from design tokens
 */ export const EvoBrand = {
    10: "#130D3E",
    20: "#1E155A",
    30: "#271C73",
    40: "#302690",
    50: "#392FAC",
    60: "#433AC7",
    70: "#4D43DE",
    80: "#6453E4",
    90: "#7C6EFF",
    100: "#978BFF",
    110: "#A49AFF",
    120: "#B1A8FF",
    130: "#C3BAFF",
    140: "#D4CCFF",
    150: "#E3DEFF",
    160: "#F3F0FF"
};
